import { BudgetProposalVentilationBy } from 'routes/BudgetModule/config/queries';
import {
    BudgetProposalT,
    BudgetVentilatedDataT,
    BudgetVentilatedDataWithCadrageT,
} from 'routes/BudgetModule/config/types';
import { useGetBudgetVentilatedByResource } from './getBudgetVentilatedByResource';
import { useGetBudgetVentilatedByOperation } from './getBudgetVentilatedByOperation';
import { HttpError } from 'store/APIClient';

type UseGetBudgetVentilatedReturnT = {
    query: QueryT;
    data:
        | BudgetVentilatedDataWithCadrageT[]
        | BudgetVentilatedDataT[]
        | undefined;
    isLoading: boolean;
    isError: boolean;
    error: HttpError | null;
};

export const useGetBudgetVentilated = (
    budgetProposal: BudgetProposalT,
    ventilationBy: BudgetProposalVentilationBy,
    budgetLineCode?: string,
    extraFilters?: QueryFilterT[],
): UseGetBudgetVentilatedReturnT => {
    const {
        data: byResourceData,
        isLoading: byResourceLoading,
        query: byResourceQuery,
        isError: isByRessourceError,
        error: byResourceError,
    } = useGetBudgetVentilatedByResource({
        budgetProposal,
        enabled: ventilationBy === 'resource',
        budgetLineCode,
        extraFilters,
    });
    const {
        data: byOperationData,
        isLoading: byOperationLoading,
        query: byOperationQuery,
        isError: isByOperationError,
        error: byOperationError,
    } = useGetBudgetVentilatedByOperation({
        budgetProposal,
        enabled: ventilationBy === 'operation',
    });

    return {
        query:
            ventilationBy === 'resource' ? byResourceQuery : byOperationQuery,
        data: ventilationBy === 'resource' ? byResourceData : byOperationData,
        isLoading:
            ventilationBy === 'resource'
                ? byResourceLoading
                : byOperationLoading,
        isError: isByOperationError || isByRessourceError,
        error: byResourceError || byOperationError,
    };
};
